import { render, staticRenderFns } from "./FeesOverview.vue?vue&type=template&id=62b29c3c&scoped=true&"
import script from "./FeesOverview.vue?vue&type=script&lang=js&"
export * from "./FeesOverview.vue?vue&type=script&lang=js&"
import style0 from "./FeesOverview.vue?vue&type=style&index=0&id=62b29c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b29c3c",
  null
  
)

export default component.exports